// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".createOrderPrivacy[data-v-053c5655] {\n  line-height: 24px;\n}\n.createOrderPrivacy .title[data-v-053c5655] {\n    color: #000;\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 28px;\n}\n.createOrderPrivacy .indent[data-v-053c5655] {\n    text-indent: 14px;\n}\n[data-v-053c5655] .el-dialog__footer {\n  text-align: center;\n  padding-top: 0;\n}\n", ""]);
// Exports
module.exports = exports;
